class CartDrawerDiscount extends HTMLElement {
  constructor() {
    super();

    this.applyDiscount = this.handleDiscount.bind(this);
  }

  connectedCallback() {
    this.btn = this.querySelector('#apply-discount-btn');
    this.input = this.querySelector('#discount-code');
    this.messageEl = this.querySelector('#discount-message');

    this.cartItems =
    this.closest('.cart-drawer__body').querySelector('cart-drawer-items') ||
    this.closest('.cart-drawer__body').querySelector('cart-items');

    if (this.btn) {
      this.btn.addEventListener('click', this.applyDiscount);
    }
  }

  disconnectedCallback() {
    if (this.btn) {
      this.btn.removeEventListener('click', this.applyDiscount);
    }
  }

  async handleDiscount(event) {
    event.preventDefault();
    let codeIsApplied = false;
    const code = this.input.value.trim();

    if (!code) {
      this.showMessage('Enter the code!', 'red');
      return;
    }
    
    const btn = this.querySelector('#apply-discount-btn');
    const originalText = btn.textContent;
    btn.textContent = 'Applying...';
    btn.disabled = true;

    try{
      const cartState = await this.getCart();
      const discount_codes = cartState.discount_codes;

      discount_codes.forEach(discount => {
        if (discount.code === code) {
          this.showMessage('Discount already applied!', 'red');
          codeIsApplied = true;
          btn.textContent = originalText;
          btn.disabled = false;
          return;
        }
      });
    }catch(e){
      console.error(e);
    }

    if (codeIsApplied) {
      return;
    }

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': `application/json`},
        body: JSON.stringify({
          discount: code,
          sections: this.cartItems.getSectionsToRender().map(
            section => section.section
          ),
          sections_url: window.location.pathname
        })
      });

      const cart = await response.json();

      if (response.ok && !cart.errors && cart.discount_codes[0].applicable) {
        this.cartItems.updateFreeGift(cart);

        this.cartItems.getSectionsToRender().forEach(section => {
          const elementToReplace =
          section.id === '#cart-counter'
            ? document.querySelector(section.id)
            : document.querySelector(section.selector);

          elementToReplace.innerHTML = this.cartItems.getSectionInnerHTML(
            cart.sections[section.section],
            section.selector
          );

          if(elementToReplace.classList.contains('cart-drawer__body')) {
            if(elementToReplace.querySelector('cart-drawer-discount #discount-message')){
              elementToReplace.querySelector('cart-drawer-discount #discount-message').textContent = 'Discount successfully applied ✓';
              elementToReplace.querySelector('cart-drawer-discount #discount-message').style.color = 'green';
            }
          }
        });

        updateFreeShipping();

      } else {
        this.showMessage('Incorrect or invalid code', 'red');
      }
    } catch (err) {
      this.showMessage(`Something went wrong. Please try again.`, 'red');
      console.error(err);
    } finally {
      btn.textContent = originalText;
      btn.disabled = false;
    }
  }

  showMessage(text, color) {
    this.messageEl.style.color = color;
    this.messageEl.textContent = text;
  }

  async getCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch cart');
    return await response.json();
  }
}
customElements.define('cart-drawer-discount', CartDrawerDiscount);